import {
	Component,
	ChangeDetectionStrategy,
	Output,
	EventEmitter,
	Input,
	OnInit,
	ChangeDetectorRef,
} from '@angular/core';
import { AuMapConstructClass } from '@shared/au-map-construct.class';
import { cmmsEntityCategories } from '@app/pages/cmms/configs/cmms-entity-categories';
import { FormControl } from '@angular/forms';

import { MatMenuModule } from '@angular/material/menu';
import { NgxTolgeeModule, TranslateService } from '@tolgee/ngx';

@Component({
	selector: 'cmms-entity-category',
	templateUrl: './cmms-entity-category.component.html',
	styleUrls: ['./cmms-entity-category.component.scss'],
	imports: [MatMenuModule, NgxTolgeeModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CmmsEntityCategoryComponent implements OnInit {
	@Input() set selectedCategory(category: string) {
		this.formControl.setValue(category);
	}

	@Output() categoryChanged = new EventEmitter<{ category: string }>();

	@Output() controlReady = new EventEmitter<FormControl>();

	formControl = new FormControl(null);

	entityCategories: { key: string; value: string; translatedValue: string }[] = [];
	categories: AuMapConstructClass;

	constructor(
		private cdr: ChangeDetectorRef,
		private translateService: TranslateService
	) {}

	ngOnInit(): void {
		this.controlReady.emit(this.formControl);
		this.formControl.valueChanges.subscribe(() => {
			this.cdr.detectChanges();
		});

		this.entityCategories = cmmsEntityCategories
			.map(category => ({
				...category,
				translatedValue: this.translateService.instant(category.value),
			}))
			.sort((a, b) => {
				if (a.value === 'category_none') return -1;
				if (b.value === 'category_none') return 1;
				return a.translatedValue.localeCompare(b.translatedValue);
			});

		this.categories = new AuMapConstructClass(this.entityCategories);
	}

	selectCategory(category: string): void {
		this.formControl.setValue(category, {
			emitEvent: false,
		});

		this.categoryChanged.emit({ category });
	}
}
